'use client'

import { Fragment, useEffect } from 'react'

interface ServiceModalProps {
  isOpen: boolean
  onClose: () => void
  service: {
    title: string
    icon: string
    text: string[]
    contents: {
      title: string
      text: string
    }[]
  }
}

export function ServiceModal({ isOpen, onClose, service }: ServiceModalProps) {
  // モーダルが開いている時に背景のスクロールを無効化
  useEffect(() => {
    let savedScrollY = 0

    if (isOpen) {
      // 現在のスクロール位置を保存
      savedScrollY = window.scrollY
      document.body.style.position = 'fixed'
      document.body.style.top = `-${savedScrollY}px`
      document.body.style.width = '100%'
    }

    // クリーンアップ関数でスクロール位置を復元
    return () => {
      if (isOpen) {
        document.body.style.position = ''
        document.body.style.top = ''
        document.body.style.width = ''
        window.scrollTo(0, savedScrollY)
      }
    }
  }, [isOpen])

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur"
        onClick={onClose}
      />
      <button
        onClick={onClose}
        className="fixed right-lg top-4 z-50 flex size-10 items-center justify-center rounded-full transition-colors hover:bg-white-10 md:hidden"
      >
        <span className="material-symbols-outlined !text-[24px] text-white md:text-body">
          close
        </span>
      </button>

      {/* Modal */}
      <div className="relative top-6 z-10 mx-lg max-h-[85svh] w-full max-w-6xl overflow-y-auto rounded-lg bg-white px-lg py-6 md:top-0 md:max-h-[90svh] md:py-12">
        {/* Header */}
        <div className="mb-4 flex items-center md:mb-8">
          <div className="flex items-center gap-3 md:gap-4">
            <span className="material-symbols-outlined !text-[48px] text-primary">
              {service.icon}
            </span>
            <h2 className="text-lg font-semibold text-primary md:text-xl">
              {service.title}
            </h2>
          </div>
        </div>
        <button
          onClick={onClose}
          className="absolute right-5 top-5 hidden size-10 items-center justify-center rounded-full transition-colors hover:bg-body-10 md:flex"
        >
          <span className="material-symbols-outlined !text-[24px] text-body">
            close
          </span>
        </button>

        {/* Content */}
        <ul className="grid gap-x-12 gap-y-4 md:grid-cols-2 md:gap-y-8">
          {service.contents.map((a) => (
            <li key={a.title} className="rounded-lg p-6 bg-primary-5">
              <p className="text-sm font-semibold leading-normal md:text-base">
                {a.title}
              </p>
              <p className="mt-fz-0.5 text-sm leading-little-loose text-body-65">
                {a.text}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
